import React, { Component } from 'react';
class Banner extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
            <header className="header">
                <div className="desing-banner">
                    <div className="header-green-container"></div>
                    <div className="banner-text">
                        <div className="banner-title">
                            <h1 className="fuente-monserrat"> Diseño Gráfico </h1>
                        </div>
                        <div className="banner-descrip parrafo-grande">
                            {/* <p align="justify" className="fuente-monserrat">
                                La carrera de Diseño Gráfico forma profesionales capaces de crear soluciones efectivas e innovadoras a las necesidades de diseño y de la comunicación gráfica de las organizaciones y la sociedad en general, mediante el uso eficiente de los distintos medios de expresión visual.
                            </p> */}
                        </div>
                    </div>
                </div>
            </header>
            </React.Fragment>
        );
    }
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoGrafico/Banner.jsx